import React, { PropsWithChildren } from 'react'
import { createContext } from 'lib/createContext'
import { parseErrorMessage } from 'api'
import { useAddRequirementQuestionMutation } from 'queries/requirements'

type AddQuestionModalContextState = {
  state: {
    isOpen: boolean
    mutationState: {
      isPending: boolean
      isError: boolean
      errorMessage: string | undefined
    }
  }
  actions: {
    close: () => void
    submit: ReturnType<typeof useAddRequirementQuestionMutation>['mutate']
    reset: ReturnType<typeof useAddRequirementQuestionMutation>['reset']
  }
}

const [AddQuestionModalContext, useAddQuestionModalContextValue] =
  createContext<AddQuestionModalContextState>({
    name: 'AddQuestionModalContext',
  })

type AddQuestionModalProviderProps = PropsWithChildren<{
  requirementId: number
  open: boolean
  onClose: () => void
}>

export const AddQuestionModalProvider = ({
  requirementId,
  open,
  onClose,
  children,
}: AddQuestionModalProviderProps) => {
  const { mutate, reset, isPending, isError, error } =
    useAddRequirementQuestionMutation(requirementId)

  const value: AddQuestionModalContextState = {
    state: {
      isOpen: open,
      mutationState: {
        isPending,
        isError,
        errorMessage: parseErrorMessage(error),
      },
    },
    actions: {
      close: onClose,
      submit: mutate,
      reset,
    },
  }

  return (
    <AddQuestionModalContext.Provider value={value}>
      {children}
    </AddQuestionModalContext.Provider>
  )
}

export { useAddQuestionModalContextValue }
